import { render, staticRenderFns } from "./TransloadItem.vue?vue&type=template&id=4e83e0d8&scoped=true&"
import script from "./TransloadItem.vue?vue&type=script&lang=js&"
export * from "./TransloadItem.vue?vue&type=script&lang=js&"
import style0 from "./TransloadItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TransloadItem.vue?vue&type=style&index=1&id=4e83e0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83e0d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardText,VIcon,VProgressLinear,VSpacer,VTextField,VTooltip})
